module.exports = __webpack_public_path__ + "static/media/16*9.1056b371.jpg";